import { accountAPI } from "services";
import { toast } from "sonner";
import useOffcanvasStore from "store/offcanvasStore";
import useUniversalStore from "store/universalStore";

const SubMenu = ({ account, onSelect, remindBool }) => {
    const write = useUniversalStore((state) => state.write);
    const { openOffcanvas } = useOffcanvasStore();
    // Reopen a closed account
    const reOpenAccount = async (e) => {
        e.preventDefault();
        const result = await accountAPI.reopenAccount(account.id);
        if (result) {
            // Update the accounts in the global state
            const accounts = await accountAPI.getAccounts();
            write({ accounts: accounts });
        }
    }

    const editAccount = (e) => {
        e.preventDefault();
        onSelect();
        openOffcanvas('editAccount');
    }

    const closeAccount = async (account) => {
        if (!account) return;
        if (account.get("balance") == 0) {
            const result = await accountAPI.closeAccount(account.id);
            if (result) {
                const accounts = await accountAPI.getAccounts(); //Fetch updated accounts list
                //Set the updated accounts list in global state & reset the selected account
                write({ accounts: accounts, accountId: null });
                toast.success("Account closed successfully");
            }
        } else {
            toast.error("Balance should be 0 to close account");
        }
    }

    return (
        <div className="dropdown">
            <a className="px-2 btn bg-not-transparent-on-hover mt-2"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <i className="bi bi-three-dots-vertical"></i>
            </a>
            <ul className="dropdown-menu">
                <li className="py-1 dropdown-item bg-transparent">
                    {account?.get("cancelled") ?
                        <button className="w-100 btn btn-outline-app"
                            onClick={reOpenAccount}>
                            <i className="bi bi-arrow-clockwise"></i>
                            <span className="mx-3">Reopen Account</span>
                        </button> :
                        <button className="w-100 btn btn-outline-app"
                            onClick={editAccount}>
                            <i className="bi bi-pencil-fill"></i>
                            <span className="mx-3">Edit</span>
                        </button>
                    }
                </li>
                {!account?.get("cancelled") && !remindBool ? (
                    <li className="py-1 dropdown-item bg-transparent">
                        <button className="w-100 btn btn-app"
                            // data-bs-toggle="modal" 
                            // data-bs-target="#closeAccountModal"
                            onClick={() => closeAccount(account)}
                        >
                            <i className="bi bi-x-circle-fill"></i>
                            <span className="mx-3">Close</span>
                        </button>
                    </li>
                ) : null}
            </ul>
        </div>
    )
}

export default SubMenu;